"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
function formModuleRegistryFactory(loadingService) {
    return new idm_dynamic_layout_interpreter_1.ModuleRegistryService(loadingService);
}
exports.formModuleRegistryFactory = formModuleRegistryFactory;
function fieldsProviderFactory(kbService) {
    return function (category) {
        return kbService.getMetaFields(category);
    };
}
exports.fieldsProviderFactory = fieldsProviderFactory;
var FieldsProviderFactory = /** @class */ (function () {
    function FieldsProviderFactory() {
        this.deps = [idm_kb_service_client_js_1.KbService];
        this.multi = false;
        this.provide = idm_dynamic_layout_interpreter_1.fieldsProviderKey;
        this.useFactory = fieldsProviderFactory;
    }
    return FieldsProviderFactory;
}());
exports.FieldsProviderFactory = FieldsProviderFactory;
//# sourceMappingURL=dynamic-forms-factories.js.map